


























































































































































import { Component, Mixins } from "vue-property-decorator";
import { namespace } from "vuex-class";
import _ from "lodash";
import { NavigationGuardNext, Route } from "vue-router";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import factions from "@/config/wow/factions";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";

import { getTimeSince } from "@/utils/date-helpers";

/**
 * Components
 */
/**
 * API
 */
import usersAPI, { EditCharacterKeystonesDataRequestModel } from "@/api/users";
import gameAPI, { MythicKeystoneInfoResponse } from "@/api/game";
import mixinNow from "@/mixins/now-mixin";


/**
 * Types
 */
const keystoneLevels = _.range(2, 21);


/**
 * VueX Modules
 */
const profileModule = namespace("profile");

/**
 * Page to edit his own character keystones.
 */
@Component({
	components: {},
	beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
		const that = this as CharactersMythicKeystonesPage;
		if (!that.hasUnsavedChanges) {
			return next();
		}
		const answer = window.confirm(that.$t("global.alert_leave_page") as string);
		if (answer) {
			next();
		}
		else {
			next(false);
		}
	}
})
export default class CharactersMythicKeystonesPage extends Mixins(mixinNow) {
	/// Injections
	classes = classes;
	factions = factions;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;

	keystoneLevels = keystoneLevels;

	getTimeSince = getTimeSince;


	/// Properties

	// Attributes
	isLoading = false;
	isDragging = false;
	keystoneInfos: MythicKeystoneInfoResponse[] | null = null;
	hasUnsavedChanges = false;

	data: EditCharacterKeystonesDataRequestModel[] | null = null;
	/// VueX Modules
	@profileModule.Action("fetchCharacters")
	fetchCharacters: any;
	@profileModule.State("userDetails")
	userDetails!: any;

	get headers() {
		return [
			{
				text: this.$t("character.name"),
				value: "name",
				align: "left",
				class: "collapsing"
			},
			{
				text: this.$t("character.class"),
				value: "class",
				align: "left",
				class: "collapsing"
			},
			{
				text: this.$t("character.mythic_keystone"),
				value: "mythicKeystone.id",
				align: "left"
			},
			{
				text: this.$t("character.mythic_keystone_level"),
				value: "mythicKeystone.level",
				align: "left",
				class: "collapsing"
			},
			{
				text: "",
				value: "actions",
				align: "left",
				class: "collapsing"
			},
			{
				text: this.$t("character.mythic_keystone_last_updated"),
				value: "mythicKeystone.lastSyncTime",
				align: "left",
				class: "collapsing"
			}
		];
	}

	get displayedCharacters(): any[] {
		return this.userDetails.characters;
	}

	get canSave() {
		return !this.isLoading && this.hasUnsavedChanges;
	}

	/// Methods
	async created() {
		this.isLoading = true;
		try {
			this.keystoneInfos = await gameAPI.fetchMythicKeystones();
			await this.getCharacters();

		} catch (error) {
			
		}
		this.isLoading = false;
	}

	async getCharacters() {
		await this.fetchCharacters();
		this.data = this.userDetails.characters.map((c: any) => ({
			id: c.id,
			keystoneID: c.mythicKeystone?.id,
			keystoneLevel: c.mythicKeystone != null ? c.mythicKeystone.level : 2
		}));
		this.hasUnsavedChanges = false;
	}

	async handleSaveClick() {
		if (this.data == null) {
			return;
		}

		this.isLoading = true;
		try {
			await usersAPI.editCharactersKeystones(this.data);
			await this.getCharacters();
			this.$snackbar.openInfo(this.$t("snackbar.save_success"));
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleCancelClick() {
		this.isLoading = true;
		try {
			await this.getCharacters();
		} catch (error) {
			this.handleAPIError(error);
		}
		this.isLoading = false;
	}

	async handleClearClick(characterID: string) {
		if (this.data == null) {
			return;
		}
		const correspondingItem = this.data.find(c => c.id == characterID);
		if (correspondingItem) {
			correspondingItem.keystoneLevel = 2;
			correspondingItem.keystoneID = null;
			this.hasUnsavedChanges = true;
		}

	}
}
